const MODAL_DISCLAIMER_ENABLED =
    (process.env.GATSBY_MODAL_DISCLAIMER_ENABLED ?? 'false') === 'true'

module.exports = {
  MODAL_DISCLAIMER_ENABLED,
}
